export class InputConstant {
    public static ignorePrefix: string = '__';
}